/* PDP by FN · Simplified Nutrition
   Gallery, variants, subscribe/one-time, quantity, add to cart, sticky bar and zoom for the fn-product section. */
(function () {
  if (window.__fnPdpLoaded) return;
  window.__fnPdpLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function Pdp(root) {
    this.root = root;
    var json = root.querySelector('[data-fnp-json]');
    try { this.data = JSON.parse(json ? json.textContent : '{}'); } catch (e) { this.data = { variants: [] }; }
    this.form = document.getElementById(root.getAttribute('data-form'));
    this.variantInput = root.querySelector('[data-fnp-variant-input]');
    this.variant = this.findById(this.variantInput && Number(this.variantInput.value)) || this.data.variants[0];
    this.initGallery();
    this.initOptions();
    this.initPlans();
    this.initQty();
    this.initSubmit();
    this.initSticky();
    this.initZoom();
    this.render();
  }

  Pdp.prototype.findById = function (id) {
    var vs = this.data.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i];
    return null;
  };
  Pdp.prototype.money = function (c) { return formatMoney(c, this.data.moneyFormat); };

  /* ---------- Gallery ---------- */
  Pdp.prototype.initGallery = function () {
    var self = this;
    var track = this.track = this.root.querySelector('[data-fnp-track]');
    if (!track) return;
    this.slides = Array.prototype.slice.call(track.querySelectorAll('[data-fnp-slide]'));
    this.thumbs = Array.prototype.slice.call(this.root.querySelectorAll('[data-fnp-thumb]'));
    this.dots = Array.prototype.slice.call(this.root.querySelectorAll('.fnp-dot'));
    this.counter = this.root.querySelector('[data-fnp-current]');
    this.index = 0;

    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(Number(t.getAttribute('data-fnp-thumb'))); });
    });
    var prev = this.root.querySelector('[data-fnp-prev]');
    var next = this.root.querySelector('[data-fnp-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== self.index) self.setActive(i);
      });
    }, { passive: true });
  };

  Pdp.prototype.goTo = function (i, instant) {
    if (!this.slides || !this.slides.length) return;
    var n = this.slides.length;
    i = (i + n) % n;
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  Pdp.prototype.setActive = function (i) {
    this.index = i;
    this.thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    this.dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    if (this.counter) this.counter.textContent = String(i + 1);
    var active = this.thumbs[i];
    if (active && active.parentElement && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
      var p = active.parentElement;
      p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    }
  };

  Pdp.prototype.showMedia = function (mediaId) {
    if (!mediaId || !this.slides) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (Number(this.slides[i].getAttribute('data-media-id')) === mediaId) { this.goTo(i); return; }
    }
  };

  /* ---------- Variant options ---------- */
  Pdp.prototype.initOptions = function () {
    var self = this;
    this.optionSets = Array.prototype.slice.call(this.root.querySelectorAll('[data-fnp-option]'));
    this.optionSets.forEach(function (set) {
      set.addEventListener('change', function () { self.onOptionChange(); });
    });
    this.markAvailability();
  };

  Pdp.prototype.selectedOptions = function () {
    return this.optionSets.map(function (set) {
      var c = set.querySelector('input:checked');
      return c ? c.value : null;
    });
  };

  Pdp.prototype.onOptionChange = function () {
    var opts = this.selectedOptions();
    var match = null;
    (this.data.variants || []).forEach(function (v) {
      if (match) return;
      var ok = opts.every(function (o, i) { return o === null || v.options[i] === o; });
      if (ok) match = v;
    });
    this.optionSets.forEach(function (set, i) {
      var label = set.querySelector('[data-fnp-option-value]');
      if (label) label.textContent = opts[i] || '';
    });
    this.variant = match;
    if (match) {
      if (this.variantInput) this.variantInput.value = match.id;
      if (match.media) this.showMedia(match.media);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    this.markAvailability();
    this.render();
  };

  Pdp.prototype.markAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    this.optionSets.forEach(function (set, idx) {
      set.querySelectorAll('input').forEach(function (input) {
        var test = opts.slice();
        test[idx] = input.value;
        var any = (self.data.variants || []).some(function (v) {
          return v.available && test.every(function (o, i) { return o === null || v.options[i] === o; });
        });
        input.parentElement.classList.toggle('is-unavailable', !any);
      });
    });
  };

  /* ---------- Subscribe / one-time ---------- */
  Pdp.prototype.initPlans = function () {
    var self = this;
    this.planInputs = Array.prototype.slice.call(this.root.querySelectorAll('input[name="selling_plan"]'));
    this.planSelect = this.root.querySelector('[data-fnp-plan-select]');
    this.planInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.render(); });
    });
    if (this.planSelect) {
      this.planSelect.addEventListener('change', function () {
        var sub = self.root.querySelector('input[data-fnp-mode="sub"]');
        if (sub) { sub.value = self.planSelect.value; sub.checked = true; }
        self.render();
      });
      this.planSelect.addEventListener('click', function (e) { e.stopPropagation(); });
    }
  };

  Pdp.prototype.currentPlanId = function () {
    var checked = this.planInputs && this.planInputs.filter(function (i) { return i.checked; })[0];
    return checked && checked.value ? checked.value : null;
  };

  /* ---------- Quantity ---------- */
  Pdp.prototype.initQty = function () {
    var self = this;
    this.qtyInput = this.root.querySelector('[data-fnp-qty-input]');
    this.root.querySelectorAll('[data-fnp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!self.qtyInput) return;
        var v = Math.max(1, Math.min(99, (parseInt(self.qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-fnp-qty'))));
        self.qtyInput.value = v;
        self.render();
      });
    });
    if (this.qtyInput) this.qtyInput.addEventListener('input', function () { self.render(); });
  };
  Pdp.prototype.qty = function () { return this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1; };

  /* ---------- Render prices and states ---------- */
  Pdp.prototype.render = function () {
    var self = this;
    var v = this.variant;
    var root = this.root;
    var available = !!(v && v.available);
    var planId = this.currentPlanId();
    var once = v ? v.price : 0;
    var sub = v && planId && v.plans && v.plans[planId] != null ? v.plans[planId] : null;
    var firstPlan = v && v.plans ? Object.keys(v.plans)[0] : null;
    var subDisplay = v && v.plans ? (v.plans[(this.planSelect && this.planSelect.value) || firstPlan]) : null;
    var current = sub != null ? sub : once;
    var strike = sub != null ? once : (v && v.compare > once ? v.compare : 0);
    var qty = this.qty();

    function set(sel, text) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; }); }
    set('[data-fnp-price="current"]', this.money(current));
    set('[data-fnp-price="once"]', this.money(once));
    if (subDisplay != null) set('[data-fnp-price="sub"]', this.money(subDisplay));
    set('[data-fnp-price="sub-was"]', this.money(once));
    set('[data-fnp-price="total"]', this.money(current * qty));
    root.querySelectorAll('[data-fnp-price="strike"]').forEach(function (el) {
      el.hidden = !(strike > current);
      el.textContent = self.money(strike);
    });

    var per = root.querySelector('[data-fnp-per]');
    if (per && this.data.servings > 0) per.textContent = this.money(Math.round(current / this.data.servings)) + ' ' + (per.getAttribute('data-label') || 'per serving');

    this.planInputs.forEach(function (input) {
      var card = input.closest('.fnp-plan');
      if (card) card.classList.toggle('is-on', input.checked);
    });
    root.querySelectorAll('[data-fnp-mode-label]').forEach(function (el) {
      el.textContent = sub != null ? el.getAttribute('data-sub') : el.getAttribute('data-once');
    });

    root.querySelectorAll('[data-fnp-atc]').forEach(function (btn) {
      btn.disabled = !available;
      var label = btn.querySelector('[data-fnp-atc-label]');
      if (label) label.textContent = available ? (btn.getAttribute('data-label') || 'Add to cart') : (btn.getAttribute('data-soldout') || 'Sold out');
    });

    var ship = root.querySelector('[data-fnp-ship]');
    if (ship) {
      var threshold = Number(ship.getAttribute('data-threshold')) || 0;
      var total = current * qty;
      var text = ship.querySelector('[data-fnp-ship-text]');
      var bar = ship.querySelector('[data-fnp-ship-bar]');
      if (threshold > 0) {
        if (total >= threshold) {
          text.textContent = ship.getAttribute('data-free');
          ship.classList.add('is-free');
        } else {
          text.textContent = (ship.getAttribute('data-away') || '').replace('[amount]', this.money(threshold - total)).replace('[threshold]', ship.getAttribute('data-threshold-money') || '');
          ship.classList.remove('is-free');
        }
        if (bar) bar.style.width = Math.min(100, Math.round(total * 100 / threshold)) + '%';
      }
    }
  };

  /* ---------- Add to cart ---------- */
  Pdp.prototype.initSubmit = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addToCart(e.submitter);
    });
  };

  Pdp.prototype.addToCart = function (submitter) {
    var self = this;
    var buttons = Array.prototype.slice.call(this.root.querySelectorAll('[data-fnp-atc]'));
    var err = this.root.querySelector('[data-fnp-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    var fd = new FormData(this.form);
    if (!fd.get('selling_plan')) fd.delete('selling_plan');
    if (!fd.get('quantity')) fd.set('quantity', '1');

    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && drawer.dataset && drawer.dataset.cartType === 'drawer' && typeof drawer.renderContents === 'function';
    if (useDrawer) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          if (err) { err.textContent = res.description || res.message || 'Sorry, this item could not be added.'; err.hidden = false; }
          return;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fn-product', productVariantId: self.variant && self.variant.id, cartData: res });
        }
        if (useDrawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.classList.remove('wt-cart--empty');
          drawer.renderContents(res, !document.body.classList.contains('page-overlay-cart-on'));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
      })
      .catch(function () {
        if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
      })
      .finally(function () {
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
  };

  /* ---------- Sticky bar ---------- */
  Pdp.prototype.initSticky = function () {
    var bar = this.root.querySelector('[data-fnp-sticky]');
    var buy = this.root.querySelector('[data-fnp-buy]');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('button');
    var pastBuy = false;
    var sectionVisible = true;
    function update() {
      var on = pastBuy && sectionVisible;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('fnp-sticky-on', on);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { pastBuy = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    }).observe(buy);
    var footer = document.querySelector('footer, .footer, #shopify-section-footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sectionVisible = !en.isIntersecting; });
        update();
      }).observe(footer);
    }
  };

  /* ---------- Zoom ---------- */
  Pdp.prototype.initZoom = function () {
    var self = this;
    var dialog = this.root.querySelector('[data-fnp-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      var b = this.root.querySelector('[data-fnp-zoom]');
      if (b) b.hidden = true;
      return;
    }
    function open() {
      dialog.showModal();
      document.documentElement.classList.add('fnp-zoom-open');
      var target = dialog.querySelector('img[data-index="' + self.index + '"]') || dialog.querySelectorAll('img')[self.index];
      if (target) target.scrollIntoView({ block: 'start' });
    }
    var btn = this.root.querySelector('[data-fnp-zoom]');
    if (btn) btn.addEventListener('click', open);
    if (this.slides) this.slides.forEach(function (sl) {
      var img = sl.querySelector('img');
      if (img) img.addEventListener('click', function () { if (window.matchMedia('(min-width: 901px)').matches) open(); });
    });
    var close = dialog.querySelector('[data-fnp-zoom-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('fnp-zoom-open'); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-fnp]').forEach(function (el) {
      if (el.__fnp) return;
      el.__fnp = new Pdp(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
